import React from 'react';
import { bool, oneOf, string, func } from 'prop-types';

const DeButton = ({
  plain = false,
  outline = false,
  fill = 'primary',
  onClick,
  label,
  ...props
}) => {
  let btnClass = 'de--btn';
  if (outline) {
    btnClass = `${btnClass} de--btn--outline__${fill}`;
  }
  if (!outline && !plain && fill) {
    btnClass = `${btnClass} de--btn__${fill}`;
  }
  if (plain) {
    btnClass = `${btnClass} de--btn__plain`;
  }
  return (
    <button onClick={onClick} type="button" className={btnClass} {...props}>
      <span>{label}</span>
    </button>
  );
};

DeButton.propTypes = {
  outline: bool,
  plain: bool,
  fill: oneOf(['primary', 'secondary']),
  label: string.isRequired,
  onClick: func.isRequired,
};

DeButton.defaultProps = {
  outline: false,
  fill: 'primary',
  plain: false,
};

export default DeButton;
